import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getnotifications<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.NOTIFICATION.GET_NOTIFICATIONS, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data?.data?.result ?? [])
        } else {
            action?.onError(resp.data)
        }
    } catch (e: any) {
        // Ensure that onError receives a consistent structure for any errors
        action?.onError({
            message: e.message || 'An unknown error occurred', // Default message
            status_code: e.status_code || 400, // Default to 400 if no status_code
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getnotifications', action: action?.type })
    }
}

export function* notificationmarkallread<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.NOTIFICATION.MARK_ALL_READ, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // Ensure that onError receives a consistent structure for any errors
        action?.onError({
            message: e.message || 'An unknown error occurred', // Default message
            status_code: e.status_code || 400, // Default to 400 if no status_code
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'notificationmarkallread', action: action?.type })
    }
}

export function* removeNotification<P, R>(action: { type: string; payload: { notification_id: string }; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.DELETE, APIS.NOTIFICATION.NOTIFICATION_DELETE, {}, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // Ensure that onError receives a consistent structure for any errors
        action?.onError({
            message: e.message || 'An unknown error occurred', // Default message
            status_code: e.status_code || 400, // Default to 400 if no status_code
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'removeNotification', action: action?.type })
    }
}
